import styled from 'styled-components';
import {
  DropdownNew as DropdownComponent,
  ListItem as DropdownItemComponent,
} from 'src/components/dropdown-new';
import { DropdownContent } from 'src/components/dropdown-new/styles';
import { layout } from '@prisjakt/ui-base';

type IconButtonProps = {
  active?: boolean;
};

export const IconButton = styled.button<IconButtonProps>`
  cursor: pointer;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 32px;
  height: 32px;
  background: rgba(255, 255, 255, 0.72);
  border-radius: 100%;
  color: ${p =>
    p.active ? p.theme.icons.callToActionHover : p.theme.icons.secondary};

  svg,
  path {
    fill: currentcolor;
  }

  &:hover {
    svg {
      color: ${p => p.theme.icons.callToActionHover};
    }
  }
`;

export const Dropdown = styled(DropdownComponent)`
  border: 0;

  ${DropdownContent} {
    top: 0;
  }
`;

export const DropdownItem = styled(DropdownItemComponent)`
  max-width: 200px;
  height: 40px;
  display: block;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;

  &:first-child {
    display: flex;
    border-bottom: 1px solid ${p => p.theme.lines.primary};
  }
`;

export const IconWrapper = styled.div`
  margin-right: ${layout.measurements.spacing050};
  color: ${p => p.theme.icons.callToAction};
`;
